export enum SciTheme {
  sci = 'sci',
  payforu = 'payforu',
  light = 'light',
}
